import { connect, mapProps } from '@formily/react';
import { CnSelect as UiSelect } from "../../components/cn-select";
import { mapSize, mapStatus } from "../__builtins__";
export var CnSelect = connect(UiSelect, mapProps(mapSize, mapStatus, { dataSource: true }));
CnSelect.displayName = 'CnSelect';
